import Vuex from "vuex";
import Vue from "vue";

import tagsView from "./modules/tagsView";
import company from "./modules/company";

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    //save in the localstorage
    userName: "",
    token: null,
    refreshToken: null,
    realName: "",
    phone: "",
    id: "75",
    leftSideMenu: [],
    permission: [],
    userRoles: [],
    orderIds: 0
  },

  modules: {
    tagsView,
    company
  }
});
